// How a chosen set of areas is named for people: "3 municipalities", "1 basic statistical unit",
// or the saved area's own name. Pure: no React, router or Firebase imports.
import type { CountryCode } from '../config/countries';
import { geoTypeNoun } from '../config/products';
import { odmTarget } from './navScope';
import { pluralize } from './plural';

/** `count` areas of one area type: areaCount(1, 'admin_level_2') is "1 municipality". */
export function areaCount(count: number, geoType: string | null | undefined, country?: CountryCode | null): string {
  const { singular, plural } = geoTypeNoun(geoType, country);
  return pluralize(count, singular, plural);
}

interface SelectionLike {
  name?: unknown;
  ids?: unknown;
  type?: unknown;
  [key: string]: unknown;
}

/**
 * What an Origin-Destination selection stands for, in a few words: a saved area's name, else the
 * number of areas with their type. Nothing chosen gives `empty`.
 */
export function selectionSummary(
  selection: SelectionLike | null | undefined,
  country: CountryCode | null,
  empty: string,
): string {
  if (!selection) return empty;
  if (typeof selection.name === 'string' && selection.name.trim() !== '') return selection.name;
  if (Array.isArray(selection.ids)) return areaCount(selection.ids.length, odmTarget(selection), country);
  return empty;
}
